import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: {},
    status: 'idle',
    error: null
}

const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.userDetails = {
                ...state.userDetails,
                ...action.payload,
            };
        },
        resetUserDetails: () => initialState
    },
});


export const getUserDetailsSelector = createSelector((state) => state?.userDetails, (userDetails) => userDetails);
export const { setUserDetails, resetUserDetails } = userDetailsSlice.actions
export default userDetailsSlice.reducer;